module.exports = __webpack_public_path__ + "img/logo.f80d11af.png";